import { ProductInfoField } from 'stylewhere/api'
import SimpleItemListReadingBase from 'core/pages/SimpleItemList/SimpleItemListReading'
import { OperationReadingProps, OperationReadingState } from 'stylewhere/shared'
import { T, __ } from 'stylewhere/shared/i18n'

interface State extends OperationReadingState {
  confirming: boolean
  barcodeItemReading: boolean
  removeModeEnabled: boolean
}

export default class SimpleItemListReading extends SimpleItemListReadingBase<OperationReadingProps<State>, State> {
  overrideProductInfoFields: () => ProductInfoField[] | undefined = () => {
    return [
      { label: __(T.misc.size), path: 'size.value' },
      { label: __(T.misc.color), path: 'color.value' },
      { label: __(T.misc.material), path: 'material.value' }
    ]
  }
}
